import { render, staticRenderFns } from "./NavigationSidebar.vue?vue&type=template&id=5e83025b&scoped=true&"
import script from "./NavigationSidebar.vue?vue&type=script&lang=js&"
export * from "./NavigationSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSidebar.vue?vue&type=style&index=0&id=5e83025b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e83025b",
  null
  
)

export default component.exports